import type React from "react";

import { Button } from "@/components/button";
import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";
import { useImage } from "@/features/request/feedback-tool/feedbackTool/image/hooks/useImage.tsx";

export function Points({
  imgRef,
}: {
  imgRef: null | React.MutableRefObject<HTMLImageElement | null>;
}) {
  const { isResizing } = useImage(imgRef);
  const { feedback, formFeedBack, selected, setFormFeedBack, setSelected } =
    useFeedbackTool();
  const image = imgRef?.current;

  if (!image) return null;

  if (isResizing) return null;

  return feedback?.map((item) => (
    <Button
      className={`
        absolute bg-white w-5 h-7 flex justify-center items-center rounded-full cursor-pointer 
             ${
               item.id === selected?.id
                 ? item.isResolved
                   ? "bg-utility-success-600 hover:bg-utility-success-600 transition-colors duration-200"
                   : "bg-button-primary-bg"
                 : item.isResolved
                   ? "bg-utility-success-600"
                   : "bg-gray-500 text-white"
             }
        z-[2]
        `}
      key={item.id}
      onPress={() => {
        if (formFeedBack) setFormFeedBack(null);
        if (item === selected) {
          return setSelected(null);
        }
        setSelected(item);
      }}
      style={{
        left: Number(item.x) * image.width,
        top: Number(item.y) * image.height,
      }}
    >
      {item.id}
    </Button>
  ));
}
